export const oracleTestimonial = {
  name: "Yvonne Reardon",
  role: "Operations Manager",
  company: "Oracle Training Consultants Ltd",
  paragraphs: [
    "Phil was very responsive throughout the build of our Oracle Training Consultants website. He listened to the challenges we were facing and put practical solutions in place to resolve them. I really appreciated how he took the time to understand what we needed and followed through with solutions that work for our business. I love the look of the new website and how it presents our business. Having a website we're proud to share makes a real difference.",
    "The website is already generating new enquiries for us, which is lovely to see. Customers can now pay using Klarna too, giving them another payment option. I'm really pleased with what Phil has created for Oracle Training Consultants. I'll definitely use Phil again in the future and would highly recommend him to anyone looking for help with their website. It's been a pleasure working with him.",
  ],
};

export const oracleTestimonialMarkdown = `## What my client says

${oracleTestimonial.paragraphs.map((paragraph) => `> ${paragraph}`).join(`
>
`)}

**${oracleTestimonial.name}**, ${oracleTestimonial.role}, ${oracleTestimonial.company}`;
